<template>
  <div class="table-search-container">
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:300px"
      allow-clear
      @search="value => $emit('onSearch', value)"
    />
    <a-button
      style="margin-left:20px;"
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      {{ addText }}
    </a-button>
  </div>
</template>
<script>
export default {
  props: ['addText'],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 20px;
    margin-right: 20px;
  }
}
</style>
